import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { useStylesContainers } from '../../../../St/comps/UseStyle';

export default function FoundationsSecondPanel(props) {

    const {
        AutoOptions,
        changTField,
        params,
        clasess,
        handleFileInputChange,
        fileImg,
        valueAutos,
        changAutos
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    const [showPic, setShowPic] = useState(false);
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}

                    justifyContent='center'

                    lg={12} md={12} sm={12} xs={12}
                >

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax_no_build"

                            label="رقم المبنى"
                            //className={clasTF.clrBlack}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            // InputProps={{ className: clasTD.input, readOnly: true }}
                            type="number"
                            name="tax_no_build"
                            value={params.tax_no_build}

                            onChange={changTField("tax_no_build")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax_name_street"
                            label=" اسم الشارع"
                            type="text"
                            name="tax_name_street"
                            value={params.tax_name_street}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_name_street")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax_name_district"
                            label="  الحي"
                            type="text"
                            name="tax_name_district"
                            value={params.tax_name_district}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_name_district")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax_name_city"
                            label="  المدينة"
                            type="text"
                            name="tax_name_city"
                            value={params.tax_name_city}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_name_city")}
                        />
                    </Grid>


                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="bsn_no"
                            label="  البلد"
                            type="text"
                            name="bsn_no"
                            value={params.tax_name_country}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_name_country")}
                        />
                    </Grid>


                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax_zip_code"
                            label="  الرمز البريدي"
                            type="number"
                            name="tax_zip_code"
                            value={params.tax_zip_code}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_zip_code")}
                        />
                    </Grid>

                    
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="bsn_no"
                            label="الرقم الاضافي للعنوان"
                            type="number"
                            name="tax_additional_address_no"
                            value={params.tax_additional_address_no}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,
                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_additional_address_no")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="bsn_no"
                            label="  رقم تسجيل القيمة المضافة"
                            type="number"
                            name="tax_additional_address_no"
                            value={params.tax_vat_registration_no}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("tax_vat_registration_no")}
                        />
                    </Grid>

                </Grid>
            </Grid>



        </React.Fragment>
    );

}